var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-data-iterator',{attrs:{"items":_vm.messages},scopedSlots:_vm._u([{key:"item",fn:function(props){return [_c('message-read-block',{attrs:{"value":props.item}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }